import { getOrderStatusIcon } from '@Utils/orderStatusIcons';

export const groupInventoryBuy = () => {
  return [
    {
      name: 'Yêu cầu đặt hàng',
      id: 5,
      icon: getOrderStatusIcon('orderRequest'),
      iconActive: getOrderStatusIcon('orderRequest'),
      color: '#EB5757',
      childId: [],
      child: [],
    },
    {
      id: 6,
      name: 'Đã đặt hàng',
      icon: getOrderStatusIcon('ordering'),
      iconActive: getOrderStatusIcon('ordering'),
      color: '#4CAABE',
      childId: [],
      child: [],
    },
    {
      id: 7,
      name: 'Đặt hàng thành công',
      icon: getOrderStatusIcon('ordered'),
      iconActive: getOrderStatusIcon('ordered'),
      color: '#52A49A',
      childId: [],
      child: [],
    },
    {
      id: 18,
      name: 'Hết hàng',
      icon: getOrderStatusIcon('outOfStock'),
      iconActive: getOrderStatusIcon('outOfStock'),
      color: '#EB5757',
      childId: [],
      child: [],
    },
  ];
};
